import api from '.';
import { RotateEquipmentListWithDocument } from '../pages/MasterData/RotateEquipmentList/rotateEquipmentListSlice';

export interface QueryRotateDocument {
  projectId: number;
  plant: string | null;
  area: string | null;
  rotateEquipmentLists: {
    rotateEquipmentListId: number;
    rotateEquipmentListDetails: {
      type: string | null;
      name: string | null;
      tag: string | null;
    }[];
    rotateAnswerIds: number[];
  }[];
}

interface ReturnTypeRotateEquipmentList {
  data: RotateEquipmentListWithDocument[];
}

export async function getRotateEquipmentListWithDocuments(
  queryRotateDocument: QueryRotateDocument
): Promise<ReturnTypeRotateEquipmentList> {
  const { data } = await api.post(
    '/rotate-equipment-lists/bulk-planning',
    queryRotateDocument
  );

  return data;
}
